import { Injectable } from '@angular/core';
import { ClientState } from 'src/app/_model/client-state';
import { Resetable } from '../../resetter/resetable';

/**
 * DataAccessObject for Client states
 */
@Injectable()
export abstract class ClientStateDaoService implements Resetable {
  /**
   * Saves the client state persistent
   * @param state the client state to be saved
   */
  public abstract saveState(state: ClientState): Promise<void>;
  /**
   *  Loads the persisted client state.
   * @returns The client persisted client state
   */
  public abstract loadState(): Promise<ClientState>;

  // Clearable Storage
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}
